"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const resources_1 = require("../../resources");
const Logo = ({ logoSVG, link, text }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { "data-clickable": link ? true : false, children: [text && (0, jsx_runtime_1.jsx)(typography_1.H4, { children: text }, void 0), (0, react_1.cloneElement)(link || (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}, void 0), {}, logoSVG ? logoSVG : (0, jsx_runtime_1.jsx)(resources_1.LogoCL_Black, {}, void 0))] }, void 0));
};
exports.Logo = Logo;
const Wrapper = styled_components_1.default.div `
  align-items: center;
  display: flex;

  &[data-clickable="true"] img,
  &[data-clickable="true"] a {
    cursor: pointer;
  }

  h4 {
    font-weight: 400;
    & + img {
      margin-left: 0.375rem;
    }
  }

  img {
    //height: 28px; big size
    height: 17px;
    width: 100px;
  }
`;
//# sourceMappingURL=Logo.js.map